export default function findIndexByProperty(arr, propName, propValue) {
  for (let i = 0; i < arr?.length; i++) {
    if (arr[i][propName] === propValue) {
      return i;
    }
  }
  return -1;
}
